
import { ref, computed, watch } from '@nuxtjs/composition-api';
import usePlaymix from '~/composable/usePlaymix';

export default {
  props: {
    identifier: {
      type: String,
      default: ''
    }
  },
  setup (props) {
    const id = computed(() => props.identifier)
    const selection = ref([])
    const data = ref(null)

    const getMix = async () => {
      const mix = await usePlaymix(id.value)
      selection.value = mix.selection
      data.value = mix.data
    }

    watch(id, getMix)

    getMix()

    return {
      selection,
      data
    }
  }
}
